/** Copy for the story top bar: the Share menu rows and the bar's own buttons (F07 / F17). */
export const STORY_SHARE_MENU_COPY = {
  collaborate: { value: "collaborate", label: "Collaborate", description: "Invite people, copy link, embed" },
  copyEmbed: { value: "copy_embed", label: "Copy embed code", description: "Paste into any page that allows iframes" },
  deliver: { value: "deliver", label: "Deliver story", description: "Send now or on a schedule" },
  export: {
    value: "export",
    label: "Export",
    description: "Download this view as a file",
    /** The row's note on a page that publishes no export of its own. */
    unavailable: "Coming soon: this page has no export yet",
  },
  distributionDescription: "Each person gets their own filtered copy",
  activeDeliveries: {
    value: "active_deliveries",
    label: "Active deliveries",
    /** The story's real distributions count. */
    scheduled: (count: number) => `${count} scheduled`,
    none: "None scheduled yet",
  },
} as const;

export const STORY_TOP_BAR_COPY = {
  search: "Search and commands",
  /** Hover reason on the disabled mode switch (distribution pages). */
  modeSwitchOffCanvas: "Build, Present and Explore apply on the story canvas.",
  /** A Share row inside the ⋯ menu (phones). */
  shareInMenu: (label: string) => `Share: ${label}`,
} as const;

/** The embed-code dialog opened from the Share menu. */
export const STORY_EMBED_COPY = {
  /** The Share row's note on a data app, which has no embed page yet. */
  dataAppUnavailable: "Coming soon: embedding a data app is not available yet",
  /** The embed link lives this many hours (30 days). */
  ttlHours: 720,
  /** The line under the code. */
  expiresNote: (date: string) => `Link works until ${date}.`,
  neverExpiresNote: "Link does not expire.",
  failed: "Could not create the embed code. Try again.",
} as const;
